export default {"src":"/_next/static/media/linkedIn.e5cc52f1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};